import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
    return (
        <div>
            <h1 className="display-4"><span className="text-danger">404 </span>
            Page Not Found</h1>
            <p className="lead">Sorry that page doesn't exist</p>
            <Link to="/" style={{color:"red"}}>Go To Home Page</Link>
        </div>
    )
}
